export default "__VITE_ASSET__618a1519__"